import { EmptyState } from '@starryui10/Components/EmptyState';
import { useServerGridContext } from '@starryui10/grids/ServerPagedGrid/ServerPageGridContext';
import React from 'react';
import { OverlayWrapper } from './OverlayWrapper';

export interface INoDataOverlayInfo {
    noItemsTitle: string;
    noItemsDescription: string;
    noItemsGraphic: image.SvgVariants;
}

export const NoDataOverlay = () => {
    const { noResultsMessage } = useServerGridContext();

    if (!noResultsMessage) return null;

    return (
        <OverlayWrapper>
            <EmptyState
                variant="Large"
                graphic={noResultsMessage!.noItemsGraphic}
                title={noResultsMessage!.noItemsTitle}
                description={noResultsMessage!.noItemsDescription}
            />
        </OverlayWrapper>
    );
};
